import { createStateAggregatorContext, useCreateStateAggregator } from '#utils/state-aggregator-context.js';

import type { ToolEventHandlerFunc, ToolUsedEventHandlerFunc } from './use-toolbar-filter.js';

export type EnabledToolFilterFunc = (tool: string) => boolean;

export type EnabledToolsContextValue = {
	enabledTools?: string[];
	disabledTools?: string[];
	filterTools: EnabledToolFilterFunc;
	onToolUsed: ToolUsedEventHandlerFunc;
	onToolSelected: ToolEventHandlerFunc;
};

export const {
	context: EnabledToolsContext,
	AddStateValue: AddEnabledToolsValue,
	useStateAggregatorAllValues: useEnabledToolsContextAllValues,
	useStateAggregatorLastValue: useEnabledToolsContextLastValue,
	useStateAggregatorProxy: useEnabledToolsContextProxy,
} = createStateAggregatorContext<EnabledToolsContextValue>();

export const SetEnabledTools = (props: { tools: string[] }) =>
	AddEnabledToolsValue({ ...props, okey: 'enabledTools', value: props.tools });

export const SetDisabledTools = (props: { tools: string[] }) =>
	AddEnabledToolsValue({ ...props, okey: 'disabledTools', value: props.tools });

export const AddEnabledToolFilter = (props: { filter: EnabledToolFilterFunc }) =>
	AddEnabledToolsValue({ ...props, okey: 'filterTools', value: props.filter });

export const AddEnabledToolUsedHandler = (props: { onToolUsed: ToolEventHandlerFunc }) =>
	AddEnabledToolsValue({ ...props, okey: 'onToolUsed', value: props.onToolUsed });

export const AddEnabledToolSelectedHandler = (props: { onToolSelected: ToolEventHandlerFunc }) =>
	AddEnabledToolsValue({ ...props, okey: 'onToolSelected', value: props.onToolSelected });

export const setUpEnabledToolsContext = () => useCreateStateAggregator<EnabledToolsContextValue>();
